import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { StoreItemResponse } from '../../types';
import { TicketRequest, TicketResponse, TicketsType } from './types';

const useUpdateTicket = <T extends TicketsType>({ ticketsType }: { ticketsType: T }) => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const updateTicket = async ({
    causeId,
    ticket,
    eventId,
    ticketId,
  }: {
    causeId: string;
    ticket: TicketRequest<T>;
    eventId: string;
    ticketId: string;
  }) => {
    const { data } = await StoreApi.put<StoreItemResponse<TicketResponse<T>>>(
      `/store_items/events/${eventId}/${ticketsType}/${ticketId}?cause_id=${causeId}`,
      { cause_id: causeId, store_item: ticket, store_item_id: eventId, uuid: ticketId }
    );
    return data.store_item;
  };

  return useMutation({
    mutationFn: updateTicket,
    onSuccess(_, variables) {
      const { eventId, causeId, ticketId } = variables;
      const tickets = ticketsType === 'tickets' ? 'tickets' : 'seasonPasses';

      const key = ticketId
        ? storeKeys.id(causeId).items.events.id(eventId)[tickets].id(ticketId).detail
        : [];
      void queryClient.invalidateQueries({ queryKey: key });
    },
  });
};

export { useUpdateTicket };
